// // import React, { useState, useEffect } from "react";
// // import config from "../../Common/Configurations/APIConfig";
// // import apiService from "../../Common/Configurations/APIService";
// // import Header from "../../Common/Layout/Header";
// // import { useAuth } from "../../Common/Configurations/AuthContext";
// // import { Link, useNavigate } from "react-router-dom";
// // import DeleteAlert from "../../Common/Layout/DeleteAlert";

// // const VisaMasterList = () => {
// //   const { user, loading } = useAuth();
// //   const navigate = useNavigate();
// //   const [lists, setLists] = useState([]);
// //   const [searchTerm, setSearchTerm] = useState("");
// //   const [showDeleteModal, setShowDeleteModal] = useState(false);
// //   const [itemToDelete, setItemToDelete] = useState(null);

// //   const GetData = async () => {
// //     try {
// //       const url = searchTerm 
// //         ? `${config.GET_ALL_VISAS}?search=${searchTerm}` 
// //         : config.GET_ALL_VISAS;
// //       const res = await apiService.get(url);
// //       setLists(res || []);
// //     } catch (error) {
// //       console.error("Error fetching visas", error);
// //     }
// //   };

// //   useEffect(() => {
// //     if (user) GetData();
// //   }, [user, searchTerm]);

// //   const handleDelete = async () => {
// //     if (itemToDelete) {
// //       await apiService.remove(config.DELETE_VISA_MASTER, itemToDelete);
// //       GetData();
// //       setShowDeleteModal(false);
// //     }
// //   };

// //   if (loading) return <p>Loading...</p>;
// //   if (!user) navigate("/");

// //   return (
// //     <div id="layout-wrapper">
// //       <Header User={user} />
// //       <div className="main-content">
// //         <div className="page-content">
// //           <div className="container-fluid">
// //             <div className="card">
// //               <div className="card-header d-flex justify-content-between align-items-center">
// //                 <h4 className="card-title mb-0">Visa Master Countries</h4>
// //                 <div className="search-box">
// //                   <input 
// //                     type="text" 
// //                     className="form-control" 
// //                     placeholder="Search country..." 
// //                     onChange={(e) => setSearchTerm(e.target.value)}
// //                   />
// //                 </div>
// //               </div>
// //               <div className="card-body">
// //                 <div className="table-responsive">
// //                   <table className="table align-middle table-nowrap">
// //                     <thead className="table-light">
// //                       <tr>
// //                         <th>Flag</th>
// //                         <th>Country Name</th>
// //                         <th>Process Type</th>
// //                         <th>Status</th>
// //                         <th>Visas Count</th>
// //                         <th>Action</th>
// //                       </tr>
// //                     </thead>
// //                     <tbody>
// //                       {lists.map((v) => (
// //                         <tr key={v.visaCountryId}>
// //                           <td>
// //                             <span className={`fi fi-${v.flagSrc?.toLowerCase()}`}></span> {v.flagSrc}
// //                           </td>
// //                           <td>{v.name}</td>
// //                           <td><span className="badge bg-info">{v.processingType}</span></td>
// //                           <td>
// //                             {v.isActive ? 
// //                               <span className="badge bg-success">Active</span> : 
// //                               <span className="badge bg-danger">Inactive</span>
// //                             }
// //                           </td>
// //                           <td>{v.visas?.length || 0} Visas</td>
// //                           <td>
// //                             <div className="hstack gap-2">
// //                               <button 
// //                                 className="btn btn-sm btn-soft-primary"
// //                                 onClick={() => navigate(`/visa-master/details/${v.visaCountryId}`)}
// //                               >
// //                                 <i className="ri-eye-fill align-bottom"></i> View Details
// //                               </button>
// //                               <button 
// //                                 className="btn btn-sm btn-soft-danger"
// //                                 onClick={() => { setItemToDelete(v.visaCountryId); setShowDeleteModal(true); }}
// //                               >
// //                                 <i className="ri-delete-bin-fill align-bottom"></i>
// //                               </button>
// //                             </div>
// //                           </td>
// //                         </tr>
// //                       ))}
// //                     </tbody>
// //                   </table>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //       <DeleteAlert 
// //         show={showDeleteModal} 
// //         handleClose={() => setShowDeleteModal(false)} 
// //         handleDelete={handleDelete} 
// //       />
// //     </div>
// //   );
// // };

// // export default VisaMasterList;
// // main code 



// import React, { useState, useEffect } from "react";
// import config from "../../Common/Configurations/APIConfig";
// import apiService from "../../Common/Configurations/APIService";
// import Header from "../../Common/Layout/Header";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import { Link, useNavigate } from "react-router-dom";

// const VisaMasterList = () => {
//   const { user, loading } = useAuth();
//   const navigate = useNavigate();
//   const [lists, setLists] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");

//   const GetData = async () => {
//     try {
//       const url = searchTerm 
//         ? `${config.GET_ALL_VISAS}?search=${searchTerm}` 
//         : config.GET_ALL_VISAS;
//       const res = await apiService.get(url);
//       setLists(res || []);
//     } catch (error) {
//       console.error("Error fetching visas", error);
//     }
//   };

//   useEffect(() => {
//     if (user) GetData();
//   }, [user, searchTerm]);

//   if (loading) return <p>Loading...</p>;
//   if (!user) navigate("/");

//   return (
//     <div id="layout-wrapper">
//       <Header User={user} />
//       <div className="main-content">
//         <div className="page-content">
//           <div className="container-fluid">
//             <div className="card">
//               <div className="card-header d-flex justify-content-between align-items-center">
//                 <h4 className="card-title mb-0">Visa Master Countries</h4>
//                 <div className="search-box">
//                   <input 
//                     type="text" 
//                     className="form-control" 
//                     placeholder="Search country..." 
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                   />
//                 </div>
//               </div>
//               <div className="card-body">
//                 <div className="table-responsive">
//                   <table className="table align-middle table-nowrap">
//                     <thead className="table-light">
//                       <tr>
//                         <th>Flag</th>
//                         <th>Country Name</th>
//                         <th>Process Type</th>
//                         <th>Status</th>
//                         <th>Visas Count</th>
//                         <th>Action</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {lists.map((v) => (
//                         <tr key={v.visaCountryId}>
//                           <td>
//                             <span className={`fi fi-${v.flagSrc?.toLowerCase()}`}></span> {v.flagSrc}
//                           </td>
//                           <td>{v.name}</td>
//                           <td><span className="badge bg-info">{v.processingType}</span></td>
//                           <td>
//                             {v.isActive ? 
//                               <span className="badge bg-success">Active</span> : 
//                               <span className="badge bg-danger">Inactive</span>
//                             }
//                           </td>
//                           <td>{v.visas?.length || 0} Visas</td>
//                           <td>
//                             <div className="hstack gap-2">
//                               <button 
//                                 className="btn btn-sm btn-soft-primary"
//                                 onClick={() => navigate(`/visa-master/details/${v.visaCountryId}`)}
//                               >
//                                 <i className="ri-eye-fill align-bottom me-1"></i> View Details
//                               </button>
//                             </div>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default VisaMasterList;
// // delete button removed here 


import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { Link, useNavigate } from "react-router-dom";

const VisaMasterList = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [lists, setLists] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const GetData = async () => {
    try {
      const url = config.GET_ALL_VISAS;
      const res = await apiService.get(url);
      setLists(res || []);
    } catch (error) {
      console.error("Error fetching visas", error);
    }
  };

  useEffect(() => {
    if (user) GetData();
  }, [user]);

  if (loading) return <p>Loading...</p>;
  if (!user) navigate("/");

  // ✅ Local Filtering (ONLY CHANGE ADDED)
  const filteredLists = lists.filter((v) =>
    v.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title mb-0">Visa Master Countries</h4>
                <div className="search-box">
                  <input 
                    type="text" 
                    className="form-control" 
                    placeholder="Search country..." 
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table align-middle table-nowrap">
                    <thead className="table-light">
                      <tr>
                        <th>Flag</th>
                        <th>Country Name</th>
                        <th>Process Type</th>
                        <th>Status</th>
                        <th>Visas Count</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredLists.map((v) => (
                        <tr key={v.visaCountryId}>
                          <td>
                            <span className={`fi fi-${v.flagSrc?.toLowerCase()}`}></span> {v.flagSrc}
                          </td>
                          <td>{v.name}</td>
                          <td><span className="badge bg-info">{v.processingType}</span></td>
                          <td>
                            {v.isActive ? 
                              <span className="badge bg-success">Active</span> : 
                              <span className="badge bg-danger">Inactive</span>
                            }
                          </td>
                          <td>{v.visas?.length || 0} Visas</td>
                          <td>
                            <div className="hstack gap-2">
                              <button 
                                className="btn btn-sm btn-soft-primary"
                                onClick={() => navigate(`/visa-master/details/${v.visaCountryId}`)}
                              >
                                <i className="ri-eye-fill align-bottom me-1"></i> View Details
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisaMasterList;
